import React, { useState } from "react";
import { Input } from "antd";

const { Search } = Input;

const SearchBar = ({ onSearch }) => {
  const [searchValue, setSearchValue] = useState("");

  const handleSearch = () => {
    onSearch(searchValue);
  };

  return (
    <div style={{ textAlign: "right", marginBottom: "20px" }}>
      <Search
        placeholder="Search here ..."
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        onSearch={handleSearch}
        className="w-full md:w-[400px] mb-4"
      />
    </div>
  );
};

export default SearchBar;
